// extracted by mini-css-extract-plugin
export var csatScore = "_mn-5";
export var header = "_mn-1";
export var panelWrapper = "_mn-2";
export var postPreview = "_mn-3";
export var rightContent = "_mn-0";
export var wrappingText = "_mn-4";